module.exports = __webpack_public_path__ + "img/CS_new_icons_luggage.71674698.png";